<p>For each bidding period, there are two Bid Rounds. Each bid round has four phases:</p>
 <div class="table-responsive">     
     <table class="table table-hover">         
         <thead class="thead-">
             <tr>
                 <th> # </th>
                 <th> Phase </th>
                 <th> Description </th>
             </tr>
         </thead>
         <tbody>         
             <tr>
                 <td> 1 </td>
                 <td> Place your bids </td>
                 <td> Students place their bids on courses and sections they desire. </td>
             </tr>
             <tr>
                 <td> 2 </td>
                 <td> Number crunching </td>
                 <td> The system sorts through all of the bids and determines the winning and losing bids. </td>
             </tr>
             <tr>
                 <td> 3 </td>
                 <td> Fix your conflicts </td>
                 <td>
                     Students manage conflicts that may have occurred as a result of Processing. If you do not manage your conflicts during this phase, the system will do it for you during the next phase. Conflicts can result from:
                     <ul>
                         <li>Winning multiple sections of the same course</li>
                         <li>Winning two or more courses that meet at the same time</li>
                     </ul>
                     You may also elect to cancel a winning bid during reconciliation if you no longer desire a class, however these bid points will not be awarded back to you.
                 </td>
             </tr>
             <tr>
                 <td> 4 </td>
                 <td> System Calibration </td>
                 <td> The system will automatically resolve any conflicts on your schedule that were not resolved during Student Reconciliation. To avoid the system reconciling your schedule for you, you must reconcile your own winning bids.
                 There are no guarantees which winning bids will be cancelled if the system reconciles your schedule. </td>
             </tr>             
         </tbody>         
     </table>     
 </div>
